import { render, staticRenderFns } from "./ProfileGeneral.vue?vue&type=template&id=5844d039&scoped=true&"
import script from "./ProfileGeneral.vue?vue&type=script&lang=js&"
export * from "./ProfileGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGeneral.vue?vue&type=style&index=0&id=5844d039&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844d039",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5844d039')) {
      api.createRecord('5844d039', component.options)
    } else {
      api.reload('5844d039', component.options)
    }
    module.hot.accept("./ProfileGeneral.vue?vue&type=template&id=5844d039&scoped=true&", function () {
      api.rerender('5844d039', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProfileGeneral.vue"
export default component.exports